import './styles';

import React from 'react';

import Lightbox from 'details/components/lightbox';
import About from 'details/components/lightbox/about';

import Sharing from 'details/components/sharing';

export default class HeaderButtonBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalVisible: false
        };
    }

    render() {
        return (
            <div className="HeaderButtonBar-wrapper">
                <div className={`HeaderButtonBar`}>
                    <a className="Header-button" href={this.embedUrl} target="_blank">
                        {I18n.t('button.embed')}
                    </a>
                    <a className="Header-button" href="/about" target="_blank" onClick={e => this.handleButtonClick(e)}>
                        {I18n.t('button.about')}
                    </a>
                    <Sharing rootURL={this.props.rootURL} publication={this.props.publication} />
                </div>
                <Lightbox visible={this.state.modalVisible} onClose={this.toggleModal}>
                    <About />
                </Lightbox>
            </div>
        );
    }

    get embedUrl() {
        return this.props.publication ? `/?identifier=${this.props.publication.id}#build` : '/#build';
    }

    handleButtonClick(event) {
        event.preventDefault();

        this.setState({
            modalUrl: event.target.href,
            modalVisible: !this.state.modalVisible
        });
    }

    toggleModal = () => {
        this.setState({ modalVisible: !this.state.modalVisible });
    };
}
